import React from "react";
import { Box, Typography, useTheme, Divider } from "@mui/material";
import { tokens } from "../theme";

const SidebarSection = ({ title, icon, isCollapsed, children }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box sx={{ mt: 2, mb: 1 }}>
      {!isCollapsed && (
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              px: 3,
              py: 1,
              mb: 1
            }}
          >
            {icon && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: colors.blueAccent[400],
                  '& svg': {
                    fontSize: '18px'
                  }
                }}
              >
                {icon}
              </Box>
            )}
            <Typography
              variant="h6"
              sx={{
                color: colors.grey[400],
                fontWeight: 700,
                fontSize: '0.75rem',
                textTransform: 'uppercase',
                letterSpacing: '1.2px'
              }}
            >
              {title}
            </Typography>
          </Box>
          
          <Divider 
            sx={{ 
              mx: 2, 
              mb: 1,
              borderColor: `${colors.grey[700]}40`,
              borderWidth: '1px'
            }} 
          />
        </>
      )}
      {children}
    </Box>
  );
};

export default SidebarSection;






